const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

/**
 * Best-effort report of a frontend exception to the backend.
 * Never throws — error reporting must not itself crash the app.
 *
 * Uses raw fetch() instead of the shared api axios instance so error
 * reporting is fully decoupled from auth interceptors and cannot be
 * affected by them (e.g. 401 redirect loops).
 */
export const reportClientError = async ({ error, errorInfo }) => {
  try {
    const payload = {
      error_message: (error && (error.message || String(error))) || 'Unknown error',
      error_stack: error && error.stack ? String(error.stack).slice(0, 20000) : undefined,
      component_stack:
        errorInfo && errorInfo.componentStack
          ? String(errorInfo.componentStack).slice(0, 20000)
          : undefined,
      url: typeof window !== 'undefined' ? window.location.href.slice(0, 2048) : undefined,
      user_agent:
        typeof navigator !== 'undefined' ? String(navigator.userAgent).slice(0, 1024) : undefined,
    };
    await fetch(`${API_BASE_URL}/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
  } catch (_) {
    // Swallow — the user already saw a crash, no need to surface a second one.
  }
};
